import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import {
  launchSearchExecution as launchSearchExecutionServer,
  getSearchExecutionResult as getSearchExecutionResultServer,
  getSearchExecution as getSearchExecutionServer,
  getSearchExecutionsByOrganizationId,
} from '@/actions/searchExecutions';
import { fetchCurrentOrganization } from './organizations';
import { parseFileNameFromContentDisposition } from '@/utils/downloadUtil';

export const launchSearchExecution = async (data: any, isAnonymous = false) => {
  if (isAnonymous) {
    return launchSearchExecutionServer(data);
  } else {
    const userAccessToken = await getUserAccessToken();
    return launchSearchExecutionServer(data, userAccessToken);
  }
};

export const getSearchExecutionResult = async (data: any, isAnonymous = false) => {
  if (isAnonymous) {
    return getSearchExecutionResultServer(data);
  } else {
    const userAccessToken = await getUserAccessToken();
    return getSearchExecutionResultServer(data, userAccessToken);
  }
};

export const getSearchExecution = async (searchExecutionId: any, isAnonymous = false) => {
  if (isAnonymous) {
    return getSearchExecutionServer(searchExecutionId);
  } else {
    const userAccessToken = await getUserAccessToken();
    return getSearchExecutionServer(searchExecutionId, userAccessToken);
  }
};

export const getSearchExecutions = async (page: number = 0, size: number = 5) => {
  const organization = await fetchCurrentOrganization();
  return getSearchExecutionsByOrganizationId(organization.id, page, size);
};

export const exportSearchExecutionResult = async (searchExecutionId: any) => {
  const userAccessToken = await getUserAccessToken();
  const res = await fetch(`/api/export/search-execution?searchExecutionId=${searchExecutionId}`, {
    headers: {
      Authorization: `${userAccessToken}`,
    },
  });

  const contentDisposition = res.headers.get('Content-Disposition');
  const fileName = parseFileNameFromContentDisposition(contentDisposition);
  const blob = await res.blob();

  return { blob, fileName };
};
